import React, { useEffect, useState } from 'react';
import { Stack, Typography, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useLocalStorage from '../../hooks/useLocalStorage';
import { formatAddress } from '../eir-broadband/Broadband.util';
import styles from './style';

const MbbBanner = props => {
  const theme = useTheme();
  // const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const localStore = useLocalStorage();
  const [, setAddress] = useState('');

  useEffect(() => {
    if (localStore.getLocalStorage('PREQUAL_RESULT')) {
      const prequaledAddress = formatAddress(
        JSON.parse(localStore.getLocalStorage('PREQUAL_RESULT')).addressResponse
      );
      setAddress(prequaledAddress);
    }
  }, []);
  return (
    <>
      <Container maxWidth='lg' sx={styles(theme).BannerContainer}>
        <Stack direction='column' sx={{ justifyContent: 'center', alignItems: 'center' }}>
          {props.cmsMBBTitle ? (
            <Typography component='h1' variant='h1' sx={styles(theme).bannerTitle}>
              {props.cmsMBBTitle}
            </Typography>
          ) : (
            <Typography component='h1' variant='h1' sx={styles(theme).bannerTitle}>
              {/* 5G broadband with Ireland&apos;s No.1 5G network availability. */}
              Experience 5G broadband with 99% 5G coverage.
            </Typography>
          )}
          {/* <Typography component='p' variant='body1' sx={styles(theme).bannerSubTitle}>
            Amazing speeds, No Limits Data and all on Ireland&apos;s Largest 5G Network
          </Typography> */}
          {/* {address.length > 0 && (
            <Typography component='p' variant='body1' sx={styles(theme).bannerAddress}>
              {address}
            </Typography>
          )}
          {address.length > 0 && (
            <Typography component='p' variant='body1' sx={styles(theme).bannerCTA}>
              Change Address »
            </Typography>
          )} */}
        </Stack>
      </Container>
      {/* <Box
        component='img'
        sx={styles(theme).bannerCurve}
        src={sm ? mobileImage : desktopImage}
        alt={sm ? mobileImageAlt : desktopImageAlt}
      /> */}
    </>
  );
};

export default MbbBanner;
